<template>
  <a-dropdown v-if="userInfo.id">
    <div class="flow-root">
      <a  class="float-left h-16 py-4 text-base font-medium leading-8 text-center cursor-pointer">
      <a-icon type="user" :style="{ fontSize: '20px' }"> </a-icon>
        <span class="py-4 pl-2 left-8">{{ singnumber }}</span>
      </a> 
    </div>
    <a-menu slot="overlay" @click="handleMenuClick">
      <a-menu-item key="userinfo">
        <div class="leading-8">
          <a-icon type="user" style="font-size: 18px; line-height: 32px" />
          <span class="pl-2">个人中心</span>
        </div>
      </a-menu-item>
      <a-menu-item key="logout">
        <div class="leading-8">
          <a-icon type="poweroff" style="font-size: 18px; line-height: 32px" />
          <span class="pl-2">退出系统</span>
        </div>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
  <div class="flow-root" v-else>
    <a
      class="float-left h-16 py-4 text-base font-medium leading-8 text-center cursor-pointer"
      @click="gotoLogin"
      ><a-icon type="user" :style="{ fontSize: '20px' }"> </a-icon>
      <span v-if="userInfo.id">
        <span class="py-4 pl-2 left-8">{{ singnumber }}</span> </span
      ><span class="ml-1" v-else>登录</span>
    </a>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    computed: {
      ...mapState('user', ['userInfo']),
      singnumber() {
        return (
          this.userInfo.phone_number.slice(0, 3) + '****' + this.userInfo.phone_number.slice(7)
        );
      },
    },
    methods: {
      handleMenuClick({ key }) {
        switch (key) {
          case 'userinfo':
            this.$router.push('/admin/info');
            return;
          case 'logout':
            this.$confirm({
              title: '温馨提示',
              content: '是否退出系统',
              onOk: async () => {
                await this.$store.dispatch('user/logout');
                this.$router.push('/');
              },
            });
            return;
        }
      },
      gotoLogin() {
        if (!this.userInfo.id) {
          this.$store.commit('user/SET_LOGINSTATE', { state: 'PASSWORD' });
          this.$store.commit('user/SET_LOGINFLAG', true);
        }
        ('');
      },
      gotoSign() {
        this.$store.commit('user/SET_LOGINSTATE', { state: 'SMS_REGISTRY' });
        this.$store.commit('user/SET_LOGINFLAG', true);
      },
    },
  };
</script>
